module.exports = __webpack_public_path__ + "static/media/Confirmation Bias.a9aa55e0.jpg";